var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9965 24.0011L15.998 28.0025L11.9965 32L0 19.9996L3.9975 15.998L7.99901 19.9996L11.9965 15.998L15.998 19.9996L11.9965 24.0011Z",
    fill: "#28A745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19.9996L19.9995 32L15.998 28.0025L19.9995 24.0011L15.998 19.9996L19.9995 15.998L23.997 19.9996L28.0025 15.998L32 19.9996Z",
    fill: "#28A745"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.0005L28.0025 15.998L23.997 12.0005L19.9995 15.998L15.998 12.0005L19.9995 7.99901L15.998 4.0015L19.9995 0L32 12.0005Z",
    fill: "#28A745"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9965 7.99901L15.998 12.0005L11.9965 15.998L7.99901 12.0005L3.9975 15.998L0 12.0005L11.9965 0L15.998 4.0015L11.9965 7.99901Z",
    fill: "#28A745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo6);
export default __webpack_public_path__ + "static/media/brand-logo-6.110755e63ab6a1dd19cf5113910f5c24.svg";
export { ForwardRef as ReactComponent };